import { LocalShippingOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

interface ShipmentStatusEmptyStateProps {
  subtitle: string;
}

export function ShipmentStatusEmptyState(props: ShipmentStatusEmptyStateProps) {
  const { subtitle } = props;

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{
        borderColor: "#cecdcd",
        borderWidth: "1px",
        borderStyle: "dashed",
        borderRadius: 2,
        px: "1rem",
        py: "1.75rem",
        mt: "0.5rem",
        textAlign: "center",
      }}
    >
      <LocalShippingOutlined sx={{ fontSize: 40, color: "text.disabled" }} />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        No status updates yet
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    </Stack>
  );
}
